import { list, named, text, textarea, toggle } from '../../themes/settingFields';
import { element } from './definition';
import { look, paint, typeface } from './styleTokens';

// A stack of questions, each opening onto its answer. Sleek's "We're answerable!" band is one of these
// beside a picture; a product page's care instructions are another.
//
// The questions are a setting rather than children, because a question and its answer are one thing
// a merchant types together — the reference's own `accordion-item` is a `<details>` with a `<summary>`,
// which is exactly what this draws, so it opens and closes with no script at all and a screen reader
// hears a disclosure and not two divs.

/** What a fresh stack lands with, so the element never opens as an empty box. */
const STARTER_ITEMS = [
  { question: 'How long does shipping take?', answer: 'Shipping usually takes 3-7 business days, depending on your location.' },
  { question: 'Do you ship internationally?', answer: 'Yes, we ship internationally. Shipping costs and times vary by destination.' }
];

/** The question stack: one row per question, one open at a time or all closed. */
export const accordionElement = element('accordion', {
  label: 'Questions',
  description: 'A stack of questions that each open onto their answer.',
  category: 'Other',
  icon: 'list-tree',
  props: [
    list('items', 'Questions', [text('question', 'Question'), textarea('answer', 'Answer'),
      named('source', 'Answer comes from', [['', 'What I type'], ['product.description', 'The product\'s description']])]),
    toggle('firstOpen', 'Start with the first one open'),
    named('look', 'Look', [['boxed', 'Each in an outlined box'], ['lines', 'Rows divided by lines']])
  ],
  defaults: {
    props: { items: STARTER_ITEMS, firstOpen: true, look: 'boxed' },
    styles: look({ display: 'flex', flexDirection: 'column', gap: '12px', width: '100%', fontFamily: typeface('body'), color: paint('heading') })
  }
});
